export default __webpack_public_path__ + "static/media/rnr-sports-table-2-cn.e091e95e.webp";